export default {
  name: 'CorePrompt',
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object],
      default: () => ''
    },
    title: {
      type: String,
      default: ''
    },
    open: {
      type: Boolean,
      default: false
    },
    maxWidth: {
      type: String,
      default: '500px'
    },
    color: {
      type: String,
      default: ''
    },
    buttons: {
      type: Array,
      default: () => []
    },
    showSelect: {
      type: Boolean,
      default: false
    },
    checkBoxLable: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isOpen: this.open,
      itemIsSelected: false
    };
  },
  watch: {
    open() {
      this.isOpen = this.open;
    }
  },
  methods: {
    handleButtonClick(btnIdx) {
      this.$emit('close');
      this.$emit(this.buttons[btnIdx].emit, this.value);
    }
  }
};